import { render, staticRenderFns } from "./29_ap_tipos_proveedores.vue?vue&type=template&id=17bf2b97&scoped=true&"
import script from "./29_ap_tipos_proveedores.vue?vue&type=script&lang=js&"
export * from "./29_ap_tipos_proveedores.vue?vue&type=script&lang=js&"
import style0 from "./29_ap_tipos_proveedores.vue?vue&type=style&index=0&id=17bf2b97&scoped=true&lang=css&"
import style1 from "./29_ap_tipos_proveedores.vue?vue&type=style&index=1&id=17bf2b97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bf2b97",
  null
  
)

export default component.exports